"use client";

import Link from "next/link";
import { useTranslations } from "next-intl";
export default function Forbidden() {
  const t = useTranslations("common");
  return <div className="flex h-screen items-center justify-center bg-white" data-sentry-component="Forbidden" data-sentry-source-file="forbidden.tsx">
      <div className="text-center">
        <h2 className="mb-4 text-3xl font-bold text-tertiary">
          {t("errors.forbidden.title")}
        </h2>
        <p className="mb-2 text-gray-600">{t("errors.forbidden.message")}</p>
        <div className="mt-4">
          <Link href="/" className="rounded-md bg-primary px-4 py-2 text-white transition-colors hover:bg-primary/80" data-sentry-element="Link" data-sentry-source-file="forbidden.tsx">
            {t("actions.returnHome")}
          </Link>
        </div>
      </div>
    </div>;
}